import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router }    from '@angular/router';

import { CreatePasswordComponent } from '../forgot-credentials/password/create-password/create-password.component';
import { InternalRoutes }          from '../../../shared/data/internal-routes';

@Component({
  selector: 'pin-setup-password',
  templateUrl: './setup-password.component.html',
  imports: [CreatePasswordComponent]
})
export class SetupPasswordComponent implements OnInit {
  username: string;
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit() {
    this.username = this.route.snapshot.queryParamMap.get('username');
    if (!this.username) {
      this.router.navigate([InternalRoutes.ERROR]).then();
    }
  }
}



